import React from "react";
import cn from "classnames";

import { HeadingProps } from "../Heading.props";
import styles from "./H1.module.scss";

/**
 * @deprecated
 */
const H1: React.FC<HeadingProps> = ({ children, id, testId, className, roboto, large, semiBold }: HeadingProps): JSX.Element => {
  const headerClasses = cn(styles["h1"], { [styles.roboto]: roboto }, { [styles.large]: large }, { "semi-bold": semiBold }, className);

  return (
    <h1 className={headerClasses} id={id} data-testid={testId ? `test__${testId}` : undefined}>
      {children}
    </h1>
  );
};

/**
 * @deprecated
 */
export default H1;
